import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { PodcastsProvider as Provider, platformProviderValue } from '@shapeable/ui';

const PODCASTS_QUERY = graphql`
query PlatformAllPodcastsQuery {
  platform { allPodcasts { 
    id name path slug __typename
    intro { plain text }
    intro { text }
    content { text }
    title
    color { id name value }
    openGraph { description { plain } image { thumbnails { card { url url2x } } } }
    type { id name slug __typename }
    published
    challenges {
      openGraph { image { url } }
      _schema { label pluralLabel }
      __typename id name slug
    }
    authors {
      __typename
      openGraph { image { url } }
      id name slug path
      organisation { id name }
      linkedin
      photo { id url url2x thumbnails { bubble { url url2x } } }
    }
  } }
}
`;

export const PodcastsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={ platformProviderValue( useStaticQuery(PODCASTS_QUERY), 'allPodcasts' ) }>{children}</Provider>;
};